
export const getFile = (fullPath: string) => {
    return fullPath.replace(/^.*[\\/]/, '');
};

export default getFile;
